/**
 * PhoneDisplay - Displays phone numbers with validation highlighting
 * 
 * Invalid phone numbers are displayed in red, valid ones in normal color.
 * Supports multiple phones separated by " / "
 */

import { memo } from "react";
import { Phone } from "lucide-react";
import { validatePhoneNumbers } from "@/lib/phoneUtils";
import { cn } from "@/lib/utils";

interface PhoneDisplayProps {
  phoneString: string | null | undefined;
  showIcon?: boolean;
  className?: string;
}

export const PhoneDisplay = memo(function PhoneDisplay({
  phoneString,
  showIcon = true,
  className,
}: PhoneDisplayProps) {
  if (!phoneString) return null;
  
  const phones = validatePhoneNumbers(phoneString);
  
  if (phones.length === 0) return null;
  
  return (
    <span className={cn("flex items-center gap-0.5", className)}>
      {showIcon && <Phone className="h-3 w-3 shrink-0" />}
      {phones.map((p, i) => (
        <span key={i} className="inline-flex items-center">
          {i > 0 && <span className="mx-0.5 text-muted-foreground">/</span>}
          <span className={cn(
            p.isValid ? "" : "text-destructive font-medium"
          )}>
            {p.phone}
          </span>
        </span>
      ))}
    </span>
  );
});
